import { render, staticRenderFns } from "./ProvidersFilters.vue?vue&type=template&id=aad2a35c"
import script from "./ProvidersFilters.vue?vue&type=script&lang=js"
export * from "./ProvidersFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports